class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    //[Addition] when click on search icon on header, check if the menu drawer is open, then close it first before open the search bar
    if(event.target.classList.contains('modal__toggle-open', 'icon-search') || event.target.querySelector('.modal__toggle-open.icon-search') || event.target.parentElement.classList.contains('modal__toggle-open', 'icon-search')){
      document.querySelector('.menu-drawer-container.menu-opening') && document.querySelector('.menu-drawer-container.menu-opening').removeAttribute('open');
      document.body.classList.remove('overflow-hidden-tablet');
      document.querySelector('.menu-drawer-container.menu-opening summary') &&  document.querySelector('.menu-drawer-container.menu-opening summary').setAttribute('aria-expanded', 'false');
      document.querySelector('.menu-drawer-container.menu-opening') && document.querySelector('.menu-drawer-container.menu-opening').classList.remove('menu-opening');
    }
    //[Addition] when click on search icon on header, check if the menu drawer is open, then close it first before open the search bar

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if(typeof removeTrapFocus === 'function')
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
